window.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('[data-module="accordion"]').forEach(el => {
		el.querySelector('[data-accordion="toggler"]').addEventListener('click', (e) => toggleState(e));

		const toggleState = (e) => {
			el.getAttribute('aria-expanded') === 'false' ? el.setAttribute('aria-expanded', 'true') : el.setAttribute('aria-expanded', 'false');
		}
	});
});